import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react'
import { FC, Fragment } from 'react'

import { Icon } from '~/src/components/generic/PhosphorIcons/index'

import colors from '~/config/colorsScheme'

import type { i18n as I18nInstance } from 'i18next'

const LANGUAGES = [
  { code: 'en', label: 'English', icon: '🇺🇸' },
  { code: 'fr', label: 'Français', icon: '🇫🇷' },
] as const

type Props = {
  i18n: I18nInstance
}

const LanguageMenu: FC<Props> = ({ i18n }) => {
  return (
    <Menu>
      <MenuButton
        aria-label="Switch language"
        className="rounded p-2 hover:bg-gray-100"
      >
        <div className="relative">
          <Icon color={colors.gray[500]} name="GlobeIcon" size="24" />
        </div>
      </MenuButton>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <MenuItems
          anchor="bottom end"
          className="z-50 flex w-52 flex-col items-start rounded bg-white shadow-full"
        >
          {LANGUAGES.map((language) => {
            const isActive = i18n.language === language.code

            return (
              <MenuItem key={language.code}>
                <button
                  className={`flex w-full flex-row items-center gap-x-4 px-4 py-3 data-[focus]:bg-gray-100 ${
                    isActive ? 'bg-gray-100 font-semibold' : ''
                  }`}
                  onClick={() => i18n.changeLanguage(language.code)}
                >
                  <span className="text-xl leading-none">{language.icon}</span>
                  <div>{language.label}</div>
                </button>
              </MenuItem>
            )
          })}
        </MenuItems>
      </Transition>
    </Menu>
  )
}

export default LanguageMenu
